import axios from '@/plugins/axios'

// state
export const state = {
  years: [],
  monthrange: {
    minDate: null,
    maxDate: null,
  }
}

// getters
export const getters = {
  years: state => {
    return state.years
  },
  monthrange: state => {
    return state.monthrange
  },
}

// mutations
export const mutations = {
  SET_YEARS(state, years) {
    state.years = years
  },
  SET_MONTH_RANGE(state, monthrange) {
    state.monthrange = monthrange
  },
}

// actions
export const actions = {
  setYears({ commit }, years) {
    commit('SET_YEARS', years)
  },
  setMonthRange({ commit }, monthrange) {
    commit('SET_MONTH_RANGE', monthrange)
  },
}
